import { Field } from "formik";
import { Form } from "react-bootstrap";
import { GroupTitle } from "../../../../StyledComponents";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { EntranceDateSubForm, Schema as EntranceDateSchema } from '../subforms/EntranceDate';
import { StudyOfLawSubForm, Schema as StudyOfLawSchema } from '../subforms/StudyOfLaw'
import { GrantsSubForm, Schema as GrantsSchema } from '../subforms/Grants'
import { NonAcademicCommitmentSubForm, Schema as NonAcademicCommitmentSchema } from '../subforms/NonAcademicCommitment';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { PreferredLocationSubForm, Schema as PreferredLocationSchema } from '../subforms/PreferredLocation';
import { FieldsOfActivitySubForm, Schema as FieldsOfActivitySchema } from '../subforms/FieldsOfActivity';
import { StudyOfTraineeSubForm, Schema as StudyOfTraineeSchema } from '../subforms/StudyOfTrainee';

export const JuristPraktikantSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(DocumentsSchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(EntranceDateSchema)
        .concat(NameAndContactSchema(settings))
        .concat(GrantsSchema)
        .concat(NonAcademicCommitmentSchema(settings))
        .concat(PreferredLocationSchema(settings))
        .concat(FieldsOfActivitySchema(settings))
        .concat(StudyOfTraineeSchema(settings))
);

export const JuristPraktikant = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <GroupTitle>Kontaktdaten</GroupTitle>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />

            <GroupTitle>Studium</GroupTitle>
            <Field component={StudyOfTraineeSubForm} colors={colors} settings={settings} />

            <Field component={GrantsSubForm} colors={colors} settings={settings} />
            <Field component={NonAcademicCommitmentSubForm} colors={colors} settings={settings} />

            <GroupTitle>Präferierter Bereich</GroupTitle>
            <Field component={FieldsOfActivitySubForm} colors={colors} settings={settings} />

            <GroupTitle>Präferierter Standort</GroupTitle>
            <Field component={PreferredLocationSubForm} colors={colors} isRequired={true} />

            <GroupTitle>Sonstiges</GroupTitle>
            <Field component={OtherInformationSubForm} colors={colors} />

            <GroupTitle>Dokumente</GroupTitle>
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}